import { isNullOrUndefined, sanitizeUrl } from "../../store/storeFunctions";
import PropTypes from 'prop-types';
import React from "react";

class SanitizedLink extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        title: PropTypes.string,
        link: PropTypes.string.isRequired,
        label: PropTypes.string,
        empty: PropTypes.element
    }

    static defaultProps = {
        className: "link-external",
        title: undefined,
        link: undefined,
        label: undefined,
        empty: null
    }

    render() {
        const { className, title, link, label, empty } = this.props;

        const sanitizedLink = sanitizeUrl(link);

        return !isNullOrUndefined(sanitizedLink) ?
            <a className={className} target="_blank" rel="noopener noreferrer" title={title} href={sanitizedLink}>{label || sanitizedLink}</a>
            :
            !isNullOrUndefined(empty) ?
                <>{empty}</>
                :
                null;
    }
}

export default SanitizedLink;